import React from "react";
import "../myschedule.scss";
import moment from "moment";
import { DateRange } from "react-date-range";
import { Spinner } from "react-bootstrap";
import warningIcon from "../../../../assets/warning_red.svg";

const VacationCalendar = (props) => {
  const {
    confirmButton,
    vacationErrorMessage,
    dateState,
    loading,
    isEdit,
    handleDateChange,
    handleAddUpdateVacation,
  } = props;

  // Display UI ===>

  const displayErrorMsg = () => {
    return (
      <div className="vacation-calendar-err-msg">
        <div className="vacation-calendar-err-msg-icon">
          <img src={warningIcon} alt="" />
        </div>
        <div className="vacation-calendar-err-msg-text">
          One or more vacation is planned in the selected <br /> period. Please
          update your existing planned vacation.
        </div>
      </div>
    );
  };

  const displaySelectedDates = () => {
    return (
      <>
        {confirmButton && !vacationErrorMessage && (
          <div
            className="d-flex justify-content-center"
            style={{ marginBottom: "30px" }}
          >
            <div className="vacation-calendar-selected-dates">
              <span style={{ fontWeight: "500" }}>
                {`${moment(dateState[0].startDate).format(
                  "DD/MM/YYYY"
                )} to ${moment(dateState[0].endDate).format("DD/MM/YYYY")}`}
              </span>
              {` will be marked as vacation.`}
            </div>
          </div>
        )}
      </>
    );
  };

  const displayCalendar = () => {
    return (
      <>
        <div className="d-flex justify-content-around">
          <span className="small" style={{ color: "#1B2027" }}>
            START DATE
          </span>
          <span className="small" style={{ color: "#1B2027" }}>
            END DATE
          </span>
        </div>
        <div className="vacation-date-calendar">
          <DateRange
            dateDisplayFormat="dd/MM/yyyy"
            editableDateInputs={false}
            defaultValue={{
              start: dateState.startDate,
              end: dateState.endDate,
            }}
            onChange={handleDateChange}
            moveRangeOnFirstSelection={false}
            ranges={dateState}
            minDate={new Date()}
            maxDate={new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000)}
            startDatePlaceholder="DD/MM/YYYY"
            endDatePlaceholder="DD/MM/YYYY"
            initialFocusedRange={[0, 0]}
          />
        </div>
      </>
    );
  };

  const displayFooter = () => {
    let name = isEdit ? "Update & Save" : "Add Vacation";
    const commonPadding = window.innerWidth > 768 ? "7px" : "5px";

    return (
      <div className="d-flex justify-content-center">
        <button
          disabled={!confirmButton}
          className={`ml-4 mt-0 ${
            confirmButton !== true
              ? "disabled-plan-button"
              : "enabled-plan-button"
          }`}
          style={{
            marginBottom: window.innerWidth > 768 ? "20px" : "4px",
            paddingTop: loading ? commonPadding : "",
            paddingBottom: loading ? commonPadding : "",
          }}
          onClick={handleAddUpdateVacation}
        >
          {loading ? <Spinner animation="border" /> : name}
        </button>
      </div>
    );
  };

  // <===

  return (
    <div className="vacation-modal vacation-wrapper ">
      {vacationErrorMessage && displayErrorMsg()}
      {displaySelectedDates()}
      {displayCalendar()}
      {displayFooter()}
    </div>
  );
};

export default VacationCalendar;
